export default "__VITE_ASSET__Bc6Khehj__"